import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { Text, Box } from 'components/ui';
import checkoutUtils from 'utils/Checkout';
import PromiseDateAndItems from 'components/FrictionlessCheckout/ShippingMethods/PromiseDateAndItems/PromiseDateAndItems';

const { FULLFILLMENT_TYPE } = checkoutUtils;

function GetItShippedShippingGroups(props) {
    const {
        locales: { getItShipped, items },
        standardItemsQuantity,
        isPhysicalGiftCard,
        electronicShippingGroup,
        shippingMethod,
        deliveryGroups,
        isEditView
    } = props;

    const showSplitEDD = deliveryGroups?.length > 0;
    const cutOffDescriptionForSplitEdd = deliveryGroups?.length && !isPhysicalGiftCard && shippingMethod?.promiseDateSplitCutOffDescription;
    const GISDeliveryGroups =
        deliveryGroups?.length && checkoutUtils.seperateItemsinDeliveryGroupByFullfullment(deliveryGroups, FULLFILLMENT_TYPE.GIS);
    const deliveryMethods = showSplitEDD ? GISDeliveryGroups : [shippingMethod];

    return (
        <>
            <Text
                is='h4'
                fontWeight='bold'
                children={`${getItShipped} • ${items} (${standardItemsQuantity})`}
            />
            {deliveryMethods.map((deliveryMethod, index) => (
                <Box {...(showSplitEDD && { marginBottom: index !== deliveryGroups.length - 1 && 4 })}>
                    <PromiseDateAndItems
                        shippingMethod={deliveryMethod}
                        {...(!!electronicShippingGroup && index === 0 && { extraItems: electronicShippingGroup?.items })}
                        isEditView={isEditView}
                        standardOnly={true}
                        {...(showSplitEDD && {
                            showSplitEDD,
                            cutOffDescriptionForSplitEdd
                        })}
                    />
                </Box>
            ))}
        </>
    );
}

export default wrapFunctionalComponent(GetItShippedShippingGroups, 'GetItShippedShippingGroups');
